import React, { Component } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import { Input, Form, FormGroup, Label } from 'reactstrap';
import  VendVendors  from '././vendorFold/vendVendors';
import  VendSystems  from '././vendorFold/vendSystems';
import  VendServers  from '././vendorFold/vendServers';
import  VendUsers  from '././vendorFold/vendUsers';
import  VendIntegrations  from '././vendorFold/vendIntegrations';
import { connect } from 'react-redux';

class VendorDB extends Component {
    static displayName = VendorDB.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            currMode: "vendor"
        }
        this.testPermission();
    }

    async getIP() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        });
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo,
        }, () => {
            //this.recordComingHere();
            this.testPermission();
        });
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1039",
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //    //this.getUserDeptPK();
    //}

    async testPermission() {
        console.log("test permission")
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1039"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    componentDidMount() {

    }

    changeCurr(code) {//The purpose of VendorDB is to manage which top-level component is being rendered here and nothing else.
        this.setState({
            currMode: code
        })
    }

    render() {
        if (this.state.permissionFlag === false) {
            this.props.passNewPage(-1);
        }
        //if (this.props.justSwitch === true) {
        //    this.props.passNewPage(1);
        //}
        let displayPage = <div></div>
        switch (this.state.currMode) {
            case "vendor":
                displayPage = <VendVendors userData={this.props.userData} vendpk={null} renderSource={null} />//The renderSource prop is very important, I'll explain in the components themselves
                break;
            case "system":
                displayPage = <VendSystems userData={this.props.userData} syspk={null} renderSource={null} />//This is the only time renderSource will be null, to indicate it's a top-level
                break;
            case "server":
                displayPage = <VendServers userData={this.props.userData} servpk={null} renderSource={null} />
                break;
            case "user":
                displayPage = <VendUsers userData={this.props.userData} userpk={null} renderSource={null} userList={[]} />
                break;
            case "int":
                displayPage = <VendIntegrations userData={this.props.userData} intpk={null} renderSource={null} />
                break;
            default:
                displayPage = <VendVendors userData={this.props.userData} vendpk={null} renderSource={null} />
                break;
        }
        return (
            <div className="vendorWrap">
                <Form className="rightAlignCustom">
                    <FormGroup check inline>
                        &nbsp;<Input checked={this.state.currMode === "vendor" ? true : false} type="radio" name="activeFlip" id="activeFlip" onClick={() => this.changeCurr("vendor")} /><Label>Vendor</Label>
                    </FormGroup>
                    <FormGroup check inline>
                        &nbsp;<Input checked={this.state.currMode === "system" ? true : false} type="radio" name="activeFlip" id="activeFlip" onClick={() => this.changeCurr("system")} /><Label>Systems</Label>
                    </FormGroup>
                    <FormGroup check inline>
                        &nbsp;<Input checked={this.state.currMode === "server" ? true : false} type="radio" name="activeFlip" id="activeFlip" onClick={() => this.changeCurr("server")} /><Label>Servers</Label>
                    </FormGroup>
                    <FormGroup check inline>
                        &nbsp;<Input checked={this.state.currMode === "user" ? true : false} type="radio" name="activeFlip" id="activeFlip" onClick={() => this.changeCurr("user")} /><Label>Users</Label>
                    </FormGroup>
                    <FormGroup check inline>
                        &nbsp;<Input checked={this.state.currMode === "int" ? true : false} type="radio" name="activeFlip" id="activeFlip" onClick={() => this.changeCurr("int")} /><Label>Integrations</Label>
                    </FormGroup>
                </Form>
                {displayPage}
            </div>
        );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(VendorDB);